import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Login from "@/views/Login.vue";
import Home from "@/views/home/Home.vue";
import Reader from "@/views/reader/Reader.vue";
import NotFound from "@/views/NotFound.vue";
import {checkToken} from "@/modules/api/auth";
import {handleSSO} from "@/modules/api/auth";
import {claerHomeData, clearReaderData} from "@/modules/stateControl"

const routerHistory = (process.env.VUE_APP_MODE === "local") ? createWebHistory(process.env.VUE_APP_ROUTER_BASE) : createWebHashHistory(process.env.VUE_APP_ROUTER_BASE);

const router = createRouter({
    history: routerHistory,
    routes: [
        {
            path: '/',
            name: "Index",
            component: Login
        },
        {
            path: '/home',
            name: "Home",
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/reader',
            name: "Reader",
            component: Reader,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: "Login",
            component: Login
        },
        {
            path: '/:pathMatch(.*)',
            name: 'Not Found',
            component: NotFound
        }
    ]
})

router.beforeEach(async (to, from, next) => {

    const isIndex = (to.name === "Index");

    console.log("@router beforeEach");
    console.log("isIndex");
    console.log(isIndex);
    console.log("to:");
    console.log(to)

    if (isIndex && (to.query && to.query.access_token)) {

        let params = to.query;

        if (!localStorage.accessToken) {
            next({
                path: '/login',
                query: params
            });
        } else {

            await handleSSO(to.query.access_token);

            if (to.query.ebookcode) {
                next({
                    path: '/reader',
                    query:params
                });
            } else {
                next();
            }

        }

    } else if (to.matched.some(record => record.meta.requiresAuth) || isIndex) {

        if (isIndex) {

            if (!localStorage.accessToken) {
                next({
                    path: '/login'
                });
            } else {
                await checkToken(localStorage.accessToken, to.fullPath)
                next({
                    path: '/home'
                });
            }
        } else {

            if (!localStorage.accessToken) {

                /*
                let redirect;
                if (process.env.VUE_APP_MODE !== "local") {
                    redirect = `${process.env.VUE_APP_ROUTER_BASE}#${to.fullPath}`;
                } else {
                    redirect = to.fullPath;
                }*/

                let redirect = to.fullPath;

                next({
                    path: '/login',
                    query:{ redirect: redirect }
                });

                return;
            } else {
                await checkToken(localStorage.accessToken, to.fullPath)

                if (to.name === "Home") {
                    clearReaderData();
                }
                next();
            }
        }
    } else {
        if (to.name === "Login") {
            if (localStorage.accessToken) {
                await checkToken(localStorage.accessToken, to.fullPath)
                next({
                    path: '/home'
                });
            } else {
                next();
            }
        } else {
            next();
        }
    }


});


export default router